import { Button, Card, CardBody, Flex } from '@chakra-ui/react'
import { flexGroupListContext } from 'BrokerTsLib/src/context'
import type { FlexGroupPagedQuery } from 'BrokerTsLib/src/dtos'
import { useGetAll } from 'BrokerTsLib/src/hooks/useFlexGroup'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { FlexGroupList } from '@/containers/flex-group/FlexGroupList'
import { FlexGroupListFilter } from '@/containers/flex-group/FlexGroupListFilter'
import { Pagination } from '@/containers/Pagination'
import { PageWrapper } from '@/layouts/components/PageWrapper'

import { PageToolbar } from '../../containers/PageToolbar'
import { Add } from '../../icons'

export const FlexGroupListPage = () => {
  const navigate = useNavigate()

  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(15)
  const [deletedCounter, setDeletedCounter] = useState(0)
  const [filter, setFilter] = useState<FlexGroupPagedQuery>({
    name: '',
    showInvalid: false,
    pageIndex: 1,
  })

  const { data, isLoading: isLoading } = useGetAll(filter)
  const items = data?.data

  const reloadData = () => setDeletedCounter(deletedCounter + 1)

  useEffect(() => {
    setFilter({ ...filter, pageSize: pageSize, pageIndex: currentPage })
  }, [pageSize, currentPage])

  return (
    <PageWrapper
      header={<DashboardHeader title="Přehled flexibilních skupin" />}
      mainProps={{
        sx: {
          pt: { base: 0, md: 8 },
          gap: 4,
          display: 'grid',
          alignContent: 'start',
          w: '100%',
        },
      }}
    >
      <flexGroupListContext.Provider
        value={{
          loading: isLoading,
          totalCount: items?.totalCount ?? 0,
          currentPage: currentPage,
          pageSize: pageSize,
          filter: filter,
          setCurrentPage: setCurrentPage,
          setPageSize: setPageSize,
          updateFilter: setFilter,
          reload: reloadData,
        }}
      >
        <PageToolbar
          rightElements={
            <Flex sx={{ gap: 4 }}>
              <Button
                colorScheme="primary"
                onClick={() => navigate('/flex-group/create')}
              >
                <Add />
                Vytvořit novou flexibilní skupinu
              </Button>
            </Flex>
          }
        />

        <Card>
          <CardBody>
            <FlexGroupListFilter p={6} />
            <FlexGroupList flexGroups={data?.data.items ?? []} />
            <Pagination context={flexGroupListContext} />
          </CardBody>
        </Card>
      </flexGroupListContext.Provider>
    </PageWrapper>
  )
}
